module.exports = __webpack_public_path__ + "img/L_313_0.8665af08.png";